import { render, staticRenderFns } from "./InnerShadowBrIcon.vue?vue&type=template&id=68c36cee&"
import script from "./InnerShadowBrIcon.vue?vue&type=script&lang=js&"
export * from "./InnerShadowBrIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports